angular.module('filters')
    .filter('shortFriendName', () => (friend) => {

        if (angular.isUndefined(friend)) {

            return null;

        }
        if (friend.f) {

            return friend.f;

        } else if (friend.l) {

            return friend.l;

        } else if (friend.e) {

            if (friend.e.indexOf('@') >= 0) {

                return friend.e.split('@')[0];

            }
            return friend.e;

        }
        return null;

    });



// WEBPACK FOOTER //
// ./scripts/common/filters/shortFriendName.js